import {
  ANALYTICS_JLDATA_UPDATED,
  CITRUS_AD_CLICK,
  FOUNDIT_CLICK,
} from './events';
import { createDebugger } from '../debug/Debug';

const debug = createDebugger('analytics');

export * from './events';

export const dispatchAnalyticsEvent = (
  eventName,
  data = {},
  { timeout = 10000, predecessorEventName = ANALYTICS_JLDATA_UPDATED } = {}
) => {
  const event = new CustomEvent('dataStateChange', {
    detail: {
      action: eventName,
      ...data,
    },
  });

  debug(`waiting to dispatch "${eventName}": %O`, data);

  const deferredDispatchPromise = new Promise((resolve, reject) => {
    // it's reassigned after initialized.
    let wait;

    const listener = () => {
      document.body.dispatchEvent(event);
      debug(`dispatched "${eventName}": %O`, data);
      document.body.removeEventListener(predecessorEventName, listener);
      clearTimeout(wait);
      resolve(event);
    };

    debug(`adding listener for "${predecessorEventName}" event`);
    document.body.addEventListener(predecessorEventName, listener, {
      once: true,
    });

    wait = setTimeout(() => {
      debug(`timed out waiting to dispatch "${eventName}": %O`, data);
      document.body.removeEventListener(predecessorEventName, listener);

      reject();
    }, timeout);
  });

  return deferredDispatchPromise.catch(() => {
    debug(`WARNING: expected "${eventName}" to trigger but it did not.`, event);
  });
};

export const dispatchImmediateAnalyticsEvent = (eventName, data = {}) =>
  new Promise((resolve) => {
    const event = new CustomEvent('dataStateChange', {
      bubbles: true,
      detail: {
        action: eventName,
        ...data,
      },
    });

    document.body.dispatchEvent(event);

    debug(`dispatched immediate "${eventName}": %O`, data);

    resolve(event);
  });

export const dispatchCitrusAnalytics = (productId, adId) => {
  dispatchImmediateAnalyticsEvent(CITRUS_AD_CLICK, {
    productId: productId,
    adId,
    type: 'sponsoredProduct',
  });
};

export const dispatchFoundItAnalytics = (foundItParam) => {
  dispatchImmediateAnalyticsEvent(FOUNDIT_CLICK, {
    action: 'foundit_click',
    foundItParam,
  });
};
